import axios from "axios";
import { getToken } from "../utils/authStorage";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5010/api";

export interface KPIData {
  totalIncome: number;
  totalBookings: number;
  averageIncome: number;
  pendingAmount: number;
  thisMonthIncome: number;
}

export interface PaymentMethodData {
  method: string;
  amount: number;
  approved: number;
  pending: number;
  count: number;
  percentage: number;
}

export interface ProjectIncomeData {
  projectId: number;
  projectName: string;
  amount: number;
  approved: number;
  pending: number;
  count: number;
}

export interface MonthlyTimelineData {
  month: string;
  amount: number;
  approved: number;
  pending: number;
}

export interface TopBookingData {
  bookingId: number;
  customerName: string;
  unitNumber: string;
  wing: string;
  projectName: string;
  totalAmount: number;
  receivedAmount: number;
  pendingAmount: number;
}

export interface Project {
  id: number;
  name: string;
}

export interface IncomeReportData {
  kpi: KPIData;
  paymentMethodData: PaymentMethodData[];
  projectIncomeData: ProjectIncomeData[];
  monthlyTimeline: MonthlyTimelineData[];
  topBookings: TopBookingData[];
  projects: Project[];
}

export interface IncomeDetail {
  id: number;
  bookingId: number;
  customerName: string;
  projectName: string;
  unitNumber: string;
  amount: number;
  paymentDate: string;
  paymentMethod: string;
  referenceNumber: string;
  receiptNo: string;
  remarks: string;
}

class IncomeReportService {
  async getIncomeReportData(
    projectId?: string,
    dateFrom?: string,
    dateTo?: string,
    paymentMethod?: string
  ): Promise<IncomeReportData> {
    const params: any = {};
    if (projectId) params.projectId = projectId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (paymentMethod) params.paymentMethod = paymentMethod;

    const response = await axios.get(`${API_URL}/reports/income/data`, {
      params,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  }

  async getIncomeDetails(
    projectId?: string,
    dateFrom?: string,
    dateTo?: string,
    paymentMethod?: string,
    bookingId?: number
  ): Promise<{ incomes: IncomeDetail[] }> {
    const params: any = {};
    if (projectId) params.projectId = projectId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (paymentMethod) params.paymentMethod = paymentMethod;
    if (bookingId) params.bookingId = bookingId;

    const response = await axios.get(`${API_URL}/reports/income/details`, {
      params,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  }
}

export default new IncomeReportService();
